/**
 * Exportación de datos desde el navegador.
 *
 * Se genera un CSV con BOM y separador `;`: es el formato que Excel abre
 * directamente en configuración regional en español, sin agregar dependencias
 * al proyecto (las hojas con formato del panel anterior usaban PhpSpreadsheet en
 * el servidor).
 */

export type ValorExportable = string | number | null | undefined;

/** Celda escapada para CSV (`;` como separador). */
function celda(valor: ValorExportable): string {
  if (valor === null || valor === undefined) return '';

  const texto = String(valor);

  return /[";\n\r]/.test(texto) ? `"${texto.replace(/"/g, '""')}"` : texto;
}

/** Descarga un archivo de texto desde el navegador. */
function descargar(nombre: string, contenido: string, tipo: string) {
  const blob = new Blob([contenido], { type: tipo });
  const url = URL.createObjectURL(blob);
  const enlace = document.createElement('a');

  enlace.href = url;
  enlace.download = nombre;
  document.body.appendChild(enlace);
  enlace.click();
  document.body.removeChild(enlace);

  URL.revokeObjectURL(url);
}

/** Sufijo de fecha para que dos exportaciones no se sobrescriban. */
function selloDeTiempo(): string {
  const ahora = new Date();
  const dosDigitos = (valor: number) => String(valor).padStart(2, '0');

  return [
    ahora.getFullYear(),
    dosDigitos(ahora.getMonth() + 1),
    dosDigitos(ahora.getDate()),
    `${dosDigitos(ahora.getHours())}${dosDigitos(ahora.getMinutes())}`,
  ].join('-');
}

/**
 * Exporta una tabla a CSV.
 *
 * @param nombre - Nombre base del archivo (sin extensión).
 * @param encabezados - Títulos de las columnas.
 * @param filas - Matriz de valores (ya formateados como se muestran en pantalla).
 */
export function exportarCsv(nombre: string, encabezados: string[], filas: ValorExportable[][]) {
  const lineas = [encabezados.map(celda).join(';'), ...filas.map((fila) => fila.map(celda).join(';'))];

  // El BOM hace que Excel respete los acentos.
  descargar(`${nombre}-${selloDeTiempo()}.csv`, `\uFEFF${lineas.join('\r\n')}`, 'text/csv;charset=utf-8');
}
